import _ from "lodash";
import { useUser } from "../../../../../contexts/user.context";
import useAppInfo from "../../../../../hooks/appInfo.hook";
import WarningCard from "../../../../../components/publish/WarningCard";
import { Box, Typography } from "@mui/material";
import AppStatus from "../../../Main/AppStatus";
import { PLATFORMS } from "../../../../../utils/constants";

export default function ApprovalContent({ blocked }) {
  const { appInfo, isAppBeingPublished } = useAppInfo();
  const { user } = useUser();

  if (_.isEmpty(user?.subscription) && !user?.store?.platformId === PLATFORMS.CONVERTR) {
    return (
      <WarningCard
        marginY={0.1}
        content={<>
          Escolha um plano para seguir com a publicação do seu aplicativo <br /> <a href="/pricing"> Iniciar assinatura</a>
        </>}
      />
    )
  }

  if (blocked) {
    return (
      <Box>
        <Typography variant="body1">
          Antes de ser publicado, seu app passará por uma análise pela equipe do Google. Aqui, você poderá acompanhar o status até a liberação na loja.
        </Typography>
      </Box>
    )
  }

  return (
    <AppStatus
      downloadUrl={appInfo.androidDownloadUrl}
      isAppBeingPublished={isAppBeingPublished('android')}
      platformName="Android"
      publishStatus={appInfo.androidPublishStatus}
      storeName="Play Store"
      lastPublishRequestedAt={appInfo.androidLastPublishRequestedAt}
      deadlineInDays={20}
    />
  )
}